module.exports = __webpack_public_path__ + "static/media/53.5840fa26.png";